// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__Ll_2f","cell":"ColumnAccessor_cell__1ivBK","firstCellAccent":"ColumnAccessor_firstCellAccent__1w5n-"};